import * as application from 'app-webtech-core/modules/application/actions';
import * as device from 'app-webtech-core/modules/device/actions';
import * as guide from 'app-webtech-core/modules/guide/actions';
import * as layout from 'app-webtech-core/modules/layout/actions';
import * as linearChannels from 'app-webtech-core/modules/linearChannels/actions';
import * as pairedDevices from 'app-webtech-core/modules/pairedDevices/actions';
import * as player from 'app-webtech-core/modules/player/actions';
import * as playbackSession from 'app-webtech-core/modules/playbackSession/actions';
import * as vodContent from 'app-webtech-core/modules/vodContent/actions';
import * as vodGuide from 'app-webtech-core/modules/vodGuide/actions';
import * as userAccount from 'app-webtech-core/modules/userAccount/actions';
import * as podTrackerAds from 'app-webtech-core/modules/podTracker/ads/actions';
import { actionCreator } from './actionCreator';
import { ActionTypeCreator } from './actionType';
import * as ratings from 'app-webtech-core/modules/ratings/actions';
import * as ratingsDescriptors from 'app-webtech-core/modules/ratingsDescriptors/actions';

export const actions = {
  application,
  device,
  guide,
  layout,
  linearChannels,
  pairedDevices,
  player,
  playbackSession,
  podTrackerAds,
  vodContent,
  vodGuide,
  userAccount,
  ratings,
  ratingsDescriptors,
};

export { actionCreator, ActionTypeCreator };
